/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["\uC6D4", "\uD654", "\uC218", "\uBAA9", "\uAE08", "\uD1A0", "\uC77C"], e = ["1\uC6D4", "2\uC6D4", "3\uC6D4", "4\uC6D4", "5\uC6D4", "6\uC6D4", "7\uC6D4", "8\uC6D4", "9\uC6D4", "10\uC6D4", "11\uC6D4", "12\uC6D4"], t = "\uB144\uB3C4", s = "\uC5F0\uAC04", d = "\uC6D4\uAC04", n = "\uC8FC\uAC04", o = "\uC77C\uAC04", y = "\uC624\uB298", r = "\uC77C\uC815 \uC5C6\uC74C", M = "\uD558\uB8E8 \uC885\uC77C", Y = "\uC0AD\uC81C", l = "\uC77C\uC815 \uCD94\uAC00", m = "YYYY\uB144 MMMM D\uC77C dddd\uC694\uC77C", D = { weekDays: a, months: e, years: "\uB144\uB3C4", year: "\uC5F0\uAC04", month: "\uC6D4\uAC04", week: "\uC8FC\uAC04", day: "\uC77C\uAC04", today: "\uC624\uB298", noEvent: "\uC77C\uC815 \uC5C6\uC74C", allDay: "\uD558\uB8E8 \uC885\uC77C", deleteEvent: "\uC0AD\uC81C", createEvent: "\uC77C\uC815 \uCD94\uAC00", dateFormat: "YYYY\uB144 MMMM D\uC77C dddd\uC694\uC77C" };
export {
  M as allDay,
  l as createEvent,
  m as dateFormat,
  o as day,
  D as default,
  Y as deleteEvent,
  d as month,
  e as months,
  r as noEvent,
  y as today,
  n as week,
  a as weekDays,
  s as year,
  t as years
};
